
<div class="d-flex mt-1 ">

  <div class="grid formgrid p-fluid ">
       <div *ngIf="!isRespigimento  && !pratica.isRETFase3OK" class="field col-12">
        <label for="noteRET" >Note <strong>RET</strong></label>
        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="noteRET" rows="3" [autoResize]="true"  pInputTextarea [disabled]="true">{{pratica.noteRETFase3}}</textarea>
        </span>
      </div>
      <div *ngIf="!isRespigimento  && !pratica.isPSIOK" class="field col-12">
        <label for="notePSI" >Note <strong>PSI</strong></label>
        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="notePSI" rows="3" [autoResize]="true"  pInputTextarea [disabled]="true">{{pratica.notePSI}}</textarea>
        </span>
      </div> 
      <div *ngIf="!isRespigimento  && !pratica.isSubiruOK" class="field col-12">
        <label for="noteSubiru" >Note <strong>SUBIRU</strong></label>
        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="noteSubiru" rows="3" [autoResize]="true"  pInputTextarea [disabled]="true">{{pratica.noteSUBIRU}}</textarea>
        </span>
      </div> 
      <div *ngIf="!isRespigimento  && !pratica.isNT9OK" class="field col-12">
        <label for="noteNT9" >Note <strong>PACCHETTO NT9</strong></label>
        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="noteNT9" rows="3" [autoResize]="true"  pInputTextarea [disabled]="true">{{pratica.noteNT9}}</textarea>
        </span>
      </div> 
      
      <div *ngIf="isRespigimento" class="field col-12">
        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="noteRespingimento" rows="3" [autoResize]="true" class="font-bold"  pInputTextarea [disabled]="true">{{pratica.noteBocciaturaInfratel.toUpperCase()}}</textarea>
        </span>
   
    </div>
  </div>
<div class=" mt-2" style="text-align: center;">
  <button pButton pRipple icon="pi pi-cloud-download" (click)="scaricaReport()" label="SCARICA REPORT" class="p-button-outlined w-5 mt-1 mr-1"></button>

  <button pButton pRipple icon="pi pi-times" (click)="dialogRef.close(true)" label="CHIUDI" class="p-button-outlined w-5 mt-1"></button>
</div> 
<p-toast />
<p-confirmDialog /> 